module.exports = __webpack_public_path__ + "static/media/verdana-italica.0ba125ab.ttf";